<template>
  <!--
  <div class="app flex-row align-items-center"
      :style="{ backgroundImage: 'url(img/background.jpg)' }">
  -->      
  <div class="app app-body flex-row align-items-center">
    <div id="spinner" class="justify-content-center align-items-center"
        :style="{ 
          height: spinnerHeight + 'px', 
          width: spinnerWidth + 'px' }"
        v-if="procesando">
      <b-spinner id="spinner-spin" label="Loading..."></b-spinner>
    </div>

    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4 login-card">
              <b-card-body>
                <b-form>
                  <h1>Iniciar Sesión</h1>
                  <p class="text-muted">Ingrese sus credenciales de acceso</p>
                  <b-form-group>
                    <b-form-input 
                      id="apellido"
                      placeholder="Apellido" 
                      v-model.trim= "$v.apellido.$model" 
                      :state="apellidoValido"
                      type="text"
                      @blur.native="validate"
                      @focus.native="$event.target.select()">
                    </b-form-input>
                    <b-form-invalid-feedback id="apellidoFeedback">
                      {{ apellidoInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group>
                    <b-form-input 
                      id="nombre"
                      placeholder="Nombre" 
                      v-model.trim= "$v.nombre.$model" 
                      :state="nombreValido"
                      type="text"
                      @blur.native="validate"
                      @focus.native="$event.target.select()">
                    </b-form-input>
                    <b-form-invalid-feedback id="nombreFeedback">
                      {{ nombreInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group>
                    <b-input-group>
                      <b-form-input 
                        id="password"
                        placeholder="Contraseña" 
                        v-model.trim="$v.password.$model" 
                        :state="passwordValido"
                        :type="showPass ? 'text' : 'password'"
                        @blur.native="validate"
                        @focus.native="$event.target.select()">
                      </b-form-input>
                      <span class="show-hide-pass" @click="showHidePass">
                        <i :key="showPassKey" 
                          :class="{ 'fa fa-eye': !showPass, 'fa fa-eye-slash': showPass }"></i>
                      </span>
                    </b-input-group>
                    <b-form-invalid-feedback id="passwordFeedback">
                      {{ passwordInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group>
                    <b-input-group>
                      <b-form-input 
                        id="confirmedPass"
                        placeholder="Confirme su contraseña"
                        v-model.trim="$v.confirmedPass.$model" 
                        :state="confirmedPassValido"
                        :type="showConfirmedPass ? 'text' : 'password'"
                        @blur.native="validate"
                        @focus.native="$event.target.select()"
                        @keyup.enter.native.prevent="registrar">
                      </b-form-input>
                      <span class="show-hide-pass" @click="showHideConfirmedPass">
                        <i :key="showConfirmedPassKey" 
                          :class="{ 'fa fa-eye': !showConfirmedPass, 'fa fa-eye-slash': showConfirmedPass }"></i>
                      </span>
                    </b-input-group>
                    <b-form-invalid-feedback id="confirmedPassFeedback">
                      {{ confirmedPassInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" 
                        class="px-4"
                        @click.prevent="registrar">Registrar</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!-- <b-button variant="link" class="px-0">Olvidé mi contraseña</b-button> -->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown= 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, maxLength, minLength, email, sameAs } from 'vuelidate/lib/validators';
// import Alert from  '../shared/msjAlert.vue';
import { msjAlert } from '../../mixins/msjAlert';

export default {
  name: 'Registro',
  components: {
    // appAlert: Alert
  },
  mixins: [ 
    msjAlert
  ],
  data () {
    return {
      token: '',
      apellido: '',
      nombre: '',
      password: '',
      confirmedPass: '',

      noValidar: true,
      apellidoValido: null,
      apellidoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      passwordValido: null,
      passwordInvalidoMsj: '',
      confirmedPassValido: null,
      confirmedPassInvalidoMsj: '',

      showPass: false,
      showPassKey: 0,
      showConfirmedPass: false,
      showConfirmedPassKey: 0,
    }
  },
  computed: {
    procesando: {
      get: function () {
        return this.$store.getters['spinnerProcesando/procesando'];
      },
      set: function (newValue) {
      }
    },
    spinnerHeight: {
      get: function () {
        return this.$store.getters['spinnerProcesando/height'];
      },
      set: function (newValue) {
      }
    },
    spinnerWidth: {
      get: function () {
        return this.$store.getters['spinnerProcesando/width'];
      },
      set: function (newValue) {
      }
    },
  },  
  created() {
    if (this.$route.query){
      if (this.$route.query.token){
        this.token = this.$route.query.token;
      }
    }    
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'apellido' || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false;
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj = 'Debe ingresar el apellido del usuario';
          } else if (!this.$v.apellido.maxLength) {
            this.apellidoInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del usuario';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == "password" || validarTodos) {
        if (this.$v.password.$error) {
          this.passwordValido = false;
          if (!this.$v.password.required) {
            this.passwordInvalidoMsj = 'Debe ingresar la nueva contraseña.';
          } else if (!this.$v.password.minLength || !this.$v.password.maxLength || !this.$v.pass.strongPass) {
            this.passInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
            // this.passwordInvalidoMsj = 'La contraseña debe contener entre 8 y 15 caracteres.';
          }
          /*
          } else if (!this.$v.pass.minLength || !this.$v.pass.maxLength || !this.$v.pass.strongPass) {
            this.passInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
          }
          */
        } else {
          this.passwordValido = null;
          this.passwordInvalidoMsj = '';
        }
      }

      if (campo == "confirmedPass" || validarTodos) {
        if (this.$v.confirmedPass.$error) {
          this.confirmedPassValido = false;
          if (!this.$v.confirmedPass.sameAs) {
            this.confirmedPassInvalidoMsj = 'La nueva contraseña no coincide con su confirmación.';
          }
        } else {
          this.confirmedPassValido = null;
          this.confirmedPassInvalidoMsj = '';
        }
      }

    },
    registrar () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
            token: this.token,
            apellido: this.apellido.trim(),
            nombre: this.nombre.trim(),
            password: this.password
        }

        this.showSpinner();
        this.$store.dispatch('user/registrar', params)
          .then(()  => {
            this.apellido = '';
            this.nombre = '';
            this.password = '';
            this.confirmedPass = '';
            this.$v.$reset();
            this.showAlert('El registro se completó con éxito.', 'info', this.goLogin);    
          })
          .catch(error => this.showAlertError(error))
          .finally(() => this.hideSpinner())
      }
    },
    goLogin() {
      this.$router.push({ name: 'Login' });
    },
    showHidePass() {
      this.showPass = !this.showPass;
      this.showPassKey++;
    },
    showHideConfirmedPass() {
      this.showConfirmedPass = !this.showConfirmedPass;
      this.showConfirmedPassKey++;
    }
  },
  watch: {
  },
  validations: {
    apellido: {
      required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      strongPass: function(value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        // const containsSpecial = /[#?!@$%^&*-]/.test(value);
        
        // return containsUppercase && containsLowercase && containsNumber && containsSpecial;
        return containsUppercase & containsLowercase & containsNumber;
      }
      /*
      strongPass(pass) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(pass);
      } 
      */
    },
    confirmedPass: {
      sameAs: sameAs('password')
    },    
  },  
}
</script>

<style>
</style>
